import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

const MAX_SIMILARITY_POINTS = 16;

export default function SimilarityPercentage({ rawScore }) {
  const similarityPercentage = (
    (rawScore / MAX_SIMILARITY_POINTS) *
    100
  ).toFixed();

  return (
    <Grid container alignItems="center">
      <CircularProgress
        variant="determinate"
        size="1.5rem"
        value={similarityPercentage ? parseInt(similarityPercentage) : 0}
      />
      <PercentageText color="textSecondary">
        {similarityPercentage}%
      </PercentageText>
    </Grid>
  );
}

const PercentageText = styled(Typography)`
  padding-left: ${props => props.theme.spacing(1)};
`;

SimilarityPercentage.propTypes = {
  rawScore: PropTypes.number
};

SimilarityPercentage.defaultProps = {
  rawScore: 0
};
